import { Button, FormGroup, InputLabel, OutlinedInput } from '@mui/material'
import { useFormik } from 'formik'
import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { BeatLoader } from 'react-spinners'
import { Container, ContainerForm, Title } from '../../../styles/index.sty';
import AlertSnack from '../../../components/Alert/AlertSnack'
import { useAuth } from '../../../context/authContext'
import { useLists } from '../../../context/listContext'
import { insertStorageData, updateStorageData } from '../../../api/attributes.api'

export const AddStorage = () => {
  const { config } = useAuth();
  const { fetchStoragesList } = useLists();
  const navigate = useNavigate();
  const location = useLocation();
  const [ loading, setLoading ] = useState(false);
  const [open, setOpen] = useState(false);
  const [ response, setResponse ] = useState({});
  const formik = useFormik({
    initialValues: {
    storage_name: location?.state?.data?.storage_name,
    },
    onSubmit: async values => {
      setLoading(true);
      if (location?.state?.data) {
        const submit = await updateStorageData({...values, product_storage_id: location?.state?.data?.product_storage_id }, config);
        setResponse(submit);
        setOpen(true);
        fetchStoragesList();
        if(submit.status === "success") {
          navigate("/storages");
        }
      } else {
        const submit = await insertStorageData(values, config);
        setResponse(submit);
        fetchStoragesList();
        setOpen(true);
        if(submit.status === "success") {
          navigate("/storages");
        }
      }
    },
  });

  return (
    <>
    <Container>
      <Title variant='h5' className='w-[100%]'>Enter Storage Details.</Title>
      <ContainerForm>
      {open && <AlertSnack open={open} setOpen={setOpen} response={response} setLoading={setLoading} route="customers"/>}

      {loading ?
        <div className='items-center'>
          <BeatLoader color="#36d7b7" />
        </div>
        :
      <div style={{width : "60%", margin: "auto"}} >
        <FormGroup>
          <InputLabel htmlFor="storage_name">Storage Name:<span className='text-[red]'>** </span> </InputLabel>
          <OutlinedInput
            name="storage_name"
            placeholder="Enter Storage Name"
            id="storage_name"
            type="text"
            value={formik.values.storage_name}
            onChange={formik.handleChange}
            />
        </FormGroup>
        <div className='flex flex-row justify-between'>
          <Button
            type="button"
            variant='contained'
            color='info'
            onClick={() => navigate("/storages")}
            style={{
              marginTop: "1rem",
              width: "48%"
            }}
            >
            Back
          </Button>
          <Button
            type="button"
            variant='contained'
            color='info'
            onClick={formik.handleSubmit}
            style={{
              marginTop: "1rem",
              width: "48%"
            }}
            >
            Save & Continue
          </Button>
        </div>
        </div>}
      </ContainerForm>
    </Container>
    </>
  )
};
